import * as Yup from 'yup';

const ExchangeTradeValidationSchema = Yup.object().shape({
  toc: Yup.bool()
    .test('toc', 'Must agree to Terms of Service', (value) => value === true)
    .required('Required')
});

export { ExchangeTradeValidationSchema };
